import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogService, DialogRef } from '@ngneat/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

interface Data {
    title: string;
}

@Component({
    template: `
        <div class="tw-p-5">
            <div class="tw-flex tw-items-center tw-justify-between">
                <h5 class="dialog tw-margin-0">
                    <mat-icon fontSet="material-symbols-outlined"
                        >help</mat-icon
                    >
                    {{ 'GLOBAL.IDLE.ACTIVE' | translate }}
                </h5>
            </div>

            <div class="tw-pt-3 tw-pb-5 tw-text-xl">
                {{ 'GLOBAL.IDLE.STILL-ACTIVE' | translate }}
            </div>
            <div class="tw-flex tw-justify-end">
                <button
                    mat-stroked-button
                    (click)="ref.close(true)">
                    {{ 'GLOBAL.IDLE.YES' | translate }}
                </button>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatIcon,
        MatButton,
        TranslateModule,
    ],
})
export class UserIdlePopupComponent {
    constructor(public ref: DialogRef<Data, boolean>) {}
}
